import SettingsVM from './settings-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init : function(element) {
    let vm = new Vue(SettingsVM);
    vm.bindData(JSON.parse(element.dataset.settingsJson));
    vm.$mount(element);
  }
};

